import { ApplicationModule } from 'shared/modules';
import { getBackendUrl } from './getBackendUrl';

export default (internalUrl = '/admin/dashboard') => {
    return getBackendUrl(`/external/login/?redirect_url=${internalUrl}&access_token=${ApplicationModule.accessToken}`);
};
